'use client'

import React, { useEffect, useState, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { useAuthModal } from '../context/AuthModalContext'

const AutoLoginPopup = () => {
  const [mounted, setMounted] = useState(false)
  const location = useLocation()
  const { isAuthenticated } = useAuth()
  const { isOpen, openAuth, closeAuth } = useAuthModal()
  const timeoutRef = useRef(null)
  const hasTriggeredRef = useRef(false)
  const userLoggedInDuringSessionRef = useRef(false)

  useEffect(() => {
    // Only show on home page
    if (location.pathname !== '/') {
      return
    }

    setMounted(true)

    // Check if user is already logged in
    if (isAuthenticated) {
      return
    }

    // Check if popup was already closed in this session
    const popupClosed = sessionStorage.getItem('rride_login_popup_closed')
    if (popupClosed) {
      return
    }

    // Show popup after 8 seconds
    timeoutRef.current = setTimeout(() => {
      // Double-check conditions before showing
      if (
        location.pathname === '/' &&
        !isAuthenticated &&
        !sessionStorage.getItem('rride_login_popup_closed') &&
        !hasTriggeredRef.current
      ) {
        hasTriggeredRef.current = true
        userLoggedInDuringSessionRef.current = false
        openAuth('login', false)
      }
    }, 8000)

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [location.pathname, isAuthenticated, openAuth])

  // Track if user becomes authenticated while popup is open
  useEffect(() => {
    if (isOpen && isAuthenticated) {
      userLoggedInDuringSessionRef.current = true
    }
  }, [isOpen, isAuthenticated])

  // Handle close event to save to sessionStorage
  useEffect(() => {
    if (!isOpen && hasTriggeredRef.current) {
      // Only save to sessionStorage if user did NOT log in during the session
      // This means they clicked X or closed it without logging in
      if (!userLoggedInDuringSessionRef.current) {
        sessionStorage.setItem('rride_login_popup_closed', 'true')
      }
      // If they logged in during the session, don't save to sessionStorage
      // (logged-in users will never see the popup again due to isAuthenticated check)
    }
  }, [isOpen])

  return null
}

export default AutoLoginPopup